// searchResult is list of search package from search API
// watchedPackageList is the lift of container ids those are being watched

// this function is to replace the watched value of the package which has delayed watched value from the open search fetch packages API
// UI will be display the updated watched icon for the watched pacakges

export const updatedWatchedPackages = (searchResult, watchedPackageList) => {
  return searchResult?.map((result) => {
    let finalResult = watchedPackageList?.filter((packageID) => {
      return packageID === result.id;
    })[0];

    if (result.id === finalResult) {
      return { ...result, Watched: true };
    } else {
      return result;
    }
  });
};
